export default "__VITE_ASSET__40309435__"